import { Button, Card, CircularProgress, Grid, Modal, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import React from 'react';

interface IProps {
  isOpen: boolean;
  onCloseModal: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}
export const ConfirmationModal = ({ isOpen, onCloseModal, onConfirm, isLoading }: IProps) => {
  const styles = useStyles();
  return (
    <Modal open={isOpen} onClose={onCloseModal} className={styles.modal}>
      <Grid
        component={Card}
        item
        xs={10}
        sm={8}
        md={6}
        style={{ padding: '16px' }}
        container
        direction="column"
        spacing={1}
      >
        {isLoading && <CircularProgress className={styles.loadingCircular} />}
        <Typography align="center" variant="h6">
          Deseja realmente cancelar o formulário?
        </Typography>
        <div className={styles.actions}>
          <Button onClick={onCloseModal} className={styles.buttonDiscart} fullWidth>
            Cancelar
          </Button>
          <Button onClick={onConfirm} className={styles.button} fullWidth>
            Confirmar
          </Button>
        </div>
      </Grid>
    </Modal>
  );
};
